import { put, apply, select, call, takeEvery, all } from 'redux-saga/effects'
import { createAction, createReducer } from 'redux-act'
import { selector as configSelector, actions as configActions } from '~/config'

import { Entity, handleError } from '~/utils/entity-utils'

import API from '~/api'

const entityName = 'user';
const entity = new Entity(entityName, API, configSelector);

// ACTIONS
export const actions = {
  ...entity.actions,
  fetchCurrentUser: {
    request: createAction('fetch current user'),
    failure: createAction('fetch current user failure'),
    success: createAction('fetch current user success', (user) => ({user})),
  }
};

// WORKERS
export const workers = {
  ...entity.workers,
  * fetchCurrentUser(action, throwError = false) {
    try {
      const config = yield select(configSelector);
      const api = new API(config);

      const response = yield apply(api, api.callRoute, ['users/current_user/', 'GET']);

      yield put(actions.fetchCurrentUser.success(response.data));
      yield put(configActions.setActiveUser(response.data));

      try {
        if(typeof window !== 'undefined' && typeof window.sessionstack !== 'undefined') {
          window.sessionstack('identify', {
            userId: response.data.id, // Replace the USER-ID with the user id from your app
            email: response.data.email, // Not required
            displayName: response.data.display_name, // Not required
          });
        }
      } catch (e) {

      }

      return response.data;
    } catch (e) {
      yield call(handleError, e, actions.fetchCurrentUser);
      if(throwError) {
        throw e;
      }else {
        return e;
      }
    }
  }
};

// SAGA
export function * saga() {
  yield all([
    ...entity.saga,
    takeEvery(actions.fetchCurrentUser.request().type, workers.fetchCurrentUser)
  ]);
}

export const reducer = createReducer({
  [actions.fetchCurrentUser.success]: (state, payload) => {
    const { user } = payload || {};

    if(user) {
      return {
        ...state,
        [user.url]: user
      }
    }

    return state;
  },
  ...entity.reducer,
}, {});

export default {
  actions,
  workers,
  saga,
  reducer
}
